import { render, staticRenderFns } from "./saveOrUpdateSysMajor.vue?vue&type=template&id=7951491f&scoped=true&"
import script from "./saveOrUpdateSysMajor.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdateSysMajor.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdateSysMajor.vue?vue&type=style&index=0&id=7951491f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951491f",
  null
  
)

export default component.exports